
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-23f03da6&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LxmLoading.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LxmLoading.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-23f03da6!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LxmLoading.vue"),
  /* scopeId */
  "data-v-23f03da6",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/common/LxmLoading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LxmLoading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23f03da6", Component.options)
  } else {
    hotAPI.reload("data-v-23f03da6", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/LxmLoading.vue
// module id = 812
// module chunks = 0